import React, { FunctionComponent } from 'react';

interface Props {
    color: string;
    children: any;
}

const ColorLegend: FunctionComponent<Props> = ({ color, children }) => {

    return (
        <div className={'color-legend'}>
            <div className={'color-legend__color'} style={{ backgroundColor: `#${color}` }} />

            <span className={'color-legend__text'}>{ children }</span>
        </div>
    );
};

export default ColorLegend;
